import React, {Component} from 'react';
import { Route, Redirect } from 'react-router-dom';

import { isSimilarObject } from '../../helper';
import { getCurrentUser } from "../../actions/session";

export default class PrivateRouteForToken extends Component {
    state = {
        loading: false,
    }

    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        const {
            session,
            dispatch,
            location,
            computedMatch:{params},
        } = this.props;

        if((!session.isLoggedIn && !session.isFetching) && params.token) {
            this.setState({loading: true});
            
            localStorage.setItem('id_token', params.token);
            setTimeout(() => {
                dispatch(
                    getCurrentUser(
                        params.token,
                        () => {
                            let locationWithoutToken = location.pathname.replace(params.token, "");                            
                            window.location.replace(locationWithoutToken);
                            this.setState({loading: false});
                        }
                    ));
            }, 100);
        }
    }

    render() {
        const {
            session,
            computedMatch:{params},
            component: RedirectComponent
        } = this.props;

        if(this.state.loading || session.isFetching) return false;
        
        if(session.isLoggedIn) {
            return <Route {...this.props} render={props => (<RedirectComponent {...props}/>)}/>
        }

        if(params.token) {
            return <Redirect to="/signin" />
        }

        return <Redirect to="/signin" />
    }
}


// WEBPACK FOOTER //
// ./src/components/Commons/PrivateRouteForToken.js